import { useState } from 'react';
// Hooks & Utils
import { useIsMobile } from '@/hooks/useIsMobile';
import { IconButton, Paper, Radio, Typography } from '@mui/material';
// Styles & Assets
import { ArrowIcon } from '@/icons/iconComponents/sideNav';
import styles from './filter.module.css';

export default function Filter({ filterData, setFilterData, items }) {
  const notDesktop = useIsMobile(820);

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        padding: '16px',
        boxShadow: notDesktop && 'none',
        marginBottom: '16px',
      }}
      elevation={notDesktop ? 0 : 1}
    >
      <FilterGroup
        title="Payment Type"
        dataTagTitle="filterCurrencyTitle"
        dataTagButton="filterCurrencyButton"
      >
        <ul>
          {items
            .filter((item) => item.allowPurchases)
            .map((item) => (
              <li className={styles.itemList} key={item.symbol}>
                <StoreRadio
                  id={item.symbol}
                  groupName="currency"
                  label={item.symbol}
                  category={filterData}
                  setCategory={(e) => setFilterData(e.target.value)}
                  dataTagCheck={`filterCheckboxCurrency${item.symbol}`}
                  dataTagLabel={`filterCheckboxCurrencyLabel${item.symbol}`}
                  defaultChecked={filterData}
                />
              </li>
            ))}
        </ul>
      </FilterGroup>
    </Paper>
  );
}

const FilterGroup = ({ title, children, dataTagTitle, dataTagButton }) => {
  const [folderOpen, setFolderOpen] = useState(true);

  const toggleFolder = () => {
    setFolderOpen(!folderOpen);
  };

  return (
    <>
      <div className={styles.itemContainer}>
        <div className={styles.labelContainer} onClick={toggleFolder}>
          <Typography variant="body1Dark" data-core-qa={dataTagTitle}>
            {title}
          </Typography>
          <div className={styles.dropdownIconContainer}>
            <IconButton variant="text" color="grey" data-core-qa={dataTagButton}>
              <ArrowIcon
                className={
                  folderOpen ? styles.dropdownIconOpen : styles.dropdownIconClosed
                }
              />
            </IconButton>
          </div>
        </div>
        {folderOpen ? <>{children}</> : null}
      </div>
    </>
  );
};

const StoreRadio = ({
  category,
  dataTagCheck,
  dataTagLabel,
  disabled = false,
  groupName,
  id,
  label,
  setCategory,
}) => {
  const handleClick = (e) => {
    setCategory(e);
  };
  return (
    <>
      <Radio
        className={styles.checkbox}
        data-core-qa={dataTagCheck}
        id={id}
        name={groupName}
        value={id}
        onChange={(e) => handleClick(e)}
        checked={id === category}
        size="small"
      />

      <label
        htmlFor={id}
        data-core-qa={dataTagLabel}
        className={disabled ? styles.checkBoxLabelDisabled : styles.checkBoxLabel}
      >
        {label}
      </label>
    </>
  );
};
StoreRadio.muiName = Radio.muiName;
